import config from "../config/config";
import { apiConfig } from "../config/apiConfig";
import ApiService from "./apiService";
import { sharedData } from "../sharedData/sharedData";

class CorporateStructureService {
    static instance;
    
    constructor () {
        if (!CorporateStructureService.instance) {
            this.instance = this;
            this.baseUrl = config['backend-url'].endsWith('/') ? config['backend-url'].slice(0, -1) : config['backend-url'];
            this.useToken = true;
            this.dontUseToken = false;
            this.apiService = new ApiService(this.baseUrl);
        }
        return CorporateStructureService.instance;
    }

    async saveCorporateStructure( payload ) {
        const response = await this.apiService.post(
            apiConfig.corporateStructure.saveCorporateStructure,
            payload,
            this.useToken
        );
        // The section is no longer "Not Applicable" once something is saved into it, even
        // under Simplified. Update the cached applicability immediately so the banner, the
        // validation hook and Save+Next stop treating it as skippable before the next
        // /get-all-statuses call lands.
        // Only when the caller stated a status. A save that carries none (the
        // Client/Counterparty copy) must not invent "Not Validated" here — that guessed
        // value hid the Simplified banner until the next /get-all-statuses corrected it.
        // Dropping the key makes isSectionSkipped fall back until the server answers.
        if (response.ok) {
            const { corporate, ...cached } = sharedData.get("sectionStatuses") || {};
            sharedData.set("sectionStatuses",
                payload.status ? { ...cached, corporate: payload.status } : cached);
        }
        return response;
    }

    // A counterparty can be shared by two requests, so entityId alone does not identify
    // the row to read. Sent from here rather than from each caller so none of them can
    // forget it; the backend still falls back to an entity-only lookup until its query
    // refactor lands, and logs when it has to.
    async getCorporateStructure ( entityId, requestId = null ) {
        const response = await this.apiService.post(
            apiConfig.corporateStructure.getCorporateStructure,
            { entityId, requestId: requestId || sharedData.get("requestId") },
            this.useToken
        );
        return response;
    }
    async getQuickCorporateStructure ( entityId, requestId = null ) {
        const response = await this.apiService.post(
            apiConfig.corporateStructure.getquickCorporateStructure,
            { entityId, requestId: requestId || sharedData.get("requestId") },
            this.useToken
        );
        return response;
    }

}

export const corporateStructureService = new CorporateStructureService();